export enum ExpeditionType {
    Shuttle = 1,
    Container = 2,
    Other = 3,
}
